import { Box, Typography, TextField } from "@mui/material";
import React from "react";
import "./Template.scss";
import InfoIcon from "@mui/icons-material/Info";
import { t, tl } from "../../../components/translate";

interface SmsTemplateBoxProps {
  content: string;
  onChange: (content: string) => any;
  showError?: boolean;
  showCustomKeywords?: boolean;
}

export const keywords = [
  { label: "First Name", value: "clientFirstName" },
  { label: "Last Name", value: "clientLastName" },
  { label: "Due", value: "clientDueAmount" },
  { label: "Booking Date", value: "bookingDate" },
  { label: "Booking Time", value: "bookingStartTime" },
  { label: "Doctor Name", value: "bookingServiceProviderName" },
  { label: "Clinic Name", value: "resourceCentreName" }
];

const GSM7_REGEX =
  // eslint-disable-next-line no-useless-escape, max-len
  /^[@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&'()*+,\-./0-9:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà\^\{\}\\\[\~\]\|€]*$/;

const SmsTemplateBox: React.FC<SmsTemplateBoxProps> = ({
  content,
  onChange,
  showError = false,
  showCustomKeywords = false
}) => {
  const isUnicode = !GSM7_REGEX.test(content);

  const charCount = [...content].length;

  const limit = isUnicode ? 67 : 153;

  let smsCount: number;

  if (isUnicode) {
    smsCount = charCount <= 70 ? 1 : Math.ceil(charCount / limit);
  } else {
    smsCount = charCount <= 160 ? 1 : Math.ceil(charCount / limit);
  }

  return (
    <Box mt={1} mb={1}>
      <Box display="flex" flexDirection="row" marginTop="4px" marginBottom="4px">
        {showCustomKeywords &&
          keywords.map((keyword, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <Typography key={i}>
              <Box
                data-testmation="selectContent"
                className="keywordSelect"
                onClick={() => onChange(`${content}{{${keyword.value}}}`)}
              >
                {keyword.label}
              </Box>
            </Typography>
          ))}
      </Box>

      <TextField
        data-testmation="content"
        variant="outlined"
        slotProps={{ inputLabel: { shrink: true } }}
        placeholder={t("campaign.phContent")}
        margin="dense"
        fullWidth
        label={tl("campaign.content")}
        multiline
        rows={8}
        value={content}
        error={content === "" && showError}
        onChange={(e) => onChange(e.target.value)}
      />

      <Typography variant="caption">
        Count : {smsCount} SMS ({charCount} characters)
        {isUnicode && " · Unicode"}
      </Typography>
      <Box display="flex" gap={1} mt={4}>
        <InfoIcon fontSize="small" color="info" />
        <Typography variant="caption" color="text.secondary">
          English SMS: 160 chars · Unicode/Emoji SMS: 70 chars · Longer messages are split into
          multiple SMS.
        </Typography>
      </Box>
    </Box>
  );
};

export default SmsTemplateBox;
